import clsx from 'clsx';
import React, {
  PropsWithChildren,
  ClassAttributes,
  HTMLAttributes,
} from 'react';
import styles from './H3.module.css';

export const H3 = ({
  className,
  ...props
}: JSX.IntrinsicAttributes &
  ClassAttributes<HTMLHeadingElement> &
  HTMLAttributes<HTMLHeadingElement> &
  PropsWithChildren) => (
  <h3 className={clsx(styles.h3, className)} {...props} />
);
